import styled from 'styled-components'

export default styled.section`
	${props =>
		props.color
			? `background-color: ${props.color}`
			: ''}
	border-radius: 8px;
	color: white;
	cursor: pointer;
	margin: 10px 0;
	padding: 10px;
`



// WEBPACK FOOTER //
// ./src/primitives/Block.js